import styled from 'styled-components';

export const Container = styled.span`
  display: flex;
  margin-top: 5px;
  color: #600;
  font-size: 12px;
  font-style: italic;
  opacity: 0.9;
`;
